import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { AppRoutes } from "./routes";
import { injectLogoutHandler, injectRefreshHandler } from "../helpers/api";
import { useSelector, useDispatch } from "react-redux";
import { persistor } from "../index";
import { logoutThunk, setUser, updateAccessToken } from "../features/auth/presentation/store/authSlice";
import { onRefreshToken } from "../features/auth/usecases/AuthUsecases";

const App = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    // Define the logout handler
    const handleLogout = async () => {
      // Dispatch logout action to clear auth state
      // dispatch(logoutThunk({
      //   id: user?.userId.trim(),
      //   parkingId: user?.parkingId.trim(),
      // }));
      dispatch(setUser(null));
      // Purge persisted state
      await persistor.purge();

      // Redirect to login page
      navigate('/', { replace: true });
    };

    // Define the refresh handler
    const handleRefresh = async (refreshToken) => {
      try {
        // Call the /refresh endpoint to get a new Access Token
        const response = await onRefreshToken(refreshToken);
        const newAccessToken = response;

        // Update the Access Token in Redux state
        dispatch(updateAccessToken(newAccessToken));
        return newAccessToken; // Return the new Access Token
      } catch (error) {
        console.error('Failed to refresh token:', error);
        throw error; // Let the interceptor handle the failure (trigger logout)
      }
    };

    // Inject handlers into api.js
    injectLogoutHandler(handleLogout);
    injectRefreshHandler(handleRefresh);

    // Cleanup function (optional)
    return () => {
      injectLogoutHandler(null);
      injectRefreshHandler(null);
    };
  }, [user]);


  useEffect(() => {
    const languageLocaleStorage = localStorage.getItem("language");
    if (languageLocaleStorage === null) {
      localStorage.setItem("language", "kr");
    } else {
      localStorage.setItem("language", languageLocaleStorage);
    }
    i18n.changeLanguage(languageLocaleStorage ?? "kr");
    //setLanguage(language);
    // eslint-disable-next-line
  }, [i18n, location]);
  return <AppRoutes />;
};

export default App;
